export const STATUS_200 = 200;
export const STATUS_300 = 300;
export const STATUS_400 = 400;
export const DATA_LIMIT = 10;
export const NEW_DATA_LIMIT=500;
export const CHART_TYPE = {
  orderStatus: 'orderSTatus',
  sales: 'sales',
  orderData: 'orderData',
  proposalData: 'proposalData',
}

